import { useEffect } from 'react'
import { DadosContainerDefault } from '../../components/Styles'
import UsuariosExternos from '../../components/UsuariosExternos'

function UsuariosExternosPage() {
  useEffect(() => {
    document.title = 'Usuarios Externos | Gesttor'
  })
  return (
    <DadosContainerDefault>
      <UsuariosExternos />
    </DadosContainerDefault>
  )
}

export default UsuariosExternosPage